<!-- @catalog Inline text with the search match highlighted (diacritic- and case-insensitive). Use in search result lists and dropdown options instead of hand-rolling mark/span loops. -->
<template>
  <template v-for="(part, index) in parts" :key="index">
    <mark v-if="part.isMatch" class="c-highlight-text__match">{{
      part.text
    }}</mark>
    <span v-if="!part.isMatch">{{ part.text }}</span>
  </template>
</template>

<script setup lang="ts">
import { buildHighlightParts } from "shared/utils";
import { computed } from "vue";

const props = defineProps<{
  text: string;
  needle: string;
}>();

const parts = computed(() => buildHighlightParts(props.text, props.needle));
</script>

<style scoped lang="scss">
// Scoped styles keep working when this renders inside teleported popups
// (QSelect menus): the rule targets this component's own elements.
.c-highlight-text__match {
  @apply tw-rounded-sm tw-bg-blue-100 tw-text-inherit;
}
</style>
